var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{directives:[{name:"editable",rawName:"v-editable",value:(_vm.cms),expression:"cms"}],class:[_vm.name, _vm.spacing]},[_c('grid',{class:[{ 'grid--container': !_vm.fullwidth }, `${_vm.name}__grid`],attrs:{"layout":[
      {
        size: 1,
        columns: 'repeat(12, 1fr)',
        gap: '6px',
      },
      {
        size: 2,
        columns: 'repeat(24, 1fr)',
        gap: '10px',
      },
    ]}},[_c('grid-item',{class:[`${_vm.name}__grid-item`, `${_vm.name}__grid-image`],attrs:{"reverse":_vm.reverse,"layout":[
        { size: 1, x: 1, width: 12 },
        { size: 3, x: 1, width: 11 },
        { size: 1, x: 1, width: 12, reverse: true },
        { size: 3, x: 14, width: 11, reverse: true, order: 1 },
      ]}},[((_vm.cms.image || {}).filename)?_c('a-image-v2',{class:`${_vm.name}__image`,attrs:{"src":(_vm.cms.image || {}).filename,"alt":(_vm.cms.image || {}).alt,"layout":[
          { size: 0, bound: 498 },
          { size: 1, bound: 689 },
          { size: 2, bound: 413 },
          { size: 3, bound: 496 },
          { size: 4, bound: 576 },
        ]}}):_vm._e()],1),_vm._v(" "),_c('grid-item',{class:[`${_vm.name}__grid-item`, `${_vm.name}__grid-content`],attrs:{"reverse":_vm.reverse,"layout":[
        { size: 1, x: 1, width: 12 },
        { size: 3, x: 14, width: 11 },
        { size: 1, x: 1, width: 12, reverse: true },
        { size: 3, x: 1, width: 11, reverse: true },
      ]}},[_c('a-copy',{class:`${_vm.name}__content`,attrs:{"cms":_vm.cms}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }